import { emailRegex } from '..';
import { popup } from '../../../../addons/Popup';
import { store } from '../../../../App/store';
import { wait } from '../../../../utils/common';

export type AccountVersionData = {
  name: string | null;
  citizenId: string | null /* Company TAX ID */;
  email: string | null;
  phones: string[];
  shipmentAddress: string | null;
  invoiceAddress: string | null;
  companyName: string | null;
  taxAdminId: string | null;
};

export default async () => {
  await wait(0.2);

  const formValues = store.getState().accounts.accountVariables;
  const data: AccountVersionData = {
    name: formValues.name || null,
    citizenId: formValues.citizenIdNumber || null,
    taxAdminId:
      (formValues?.citizenIdNumber.length === 10 && formValues.taxAdminId) ||
      null,
    companyName:
      (formValues?.citizenIdNumber.length === 10 && formValues.companyName) ||
      null,
    email: formValues.mailAddress || null,
    phones: [
      `${formValues.phone0CountryCode} ${formValues.phone0Number}`,
      `${formValues.phone1CountryCode} ${formValues.phone1Number}`,
    ].filter((phone) => !/[A-Za-z\_]/.test(phone)),
    shipmentAddress: formValues.shipmentAddress || null,
    invoiceAddress:
      (formValues.hasInvoiceAddress
        ? formValues.invoiceAddress
        : formValues.shipmentAddress) || null,
  };

  let errorMsg: string | undefined;

  if (data.citizenId?.length === 10 && !data.companyName) {
    errorMsg =
      "Şirket adı doğrulanana kadar bekleyin. Veya vergi dairesi seçin.";
  } else if (data.citizenId?.length !== 11 && data.citizenId?.length !== 10) {
    errorMsg = "VKN / TCKN gerekli";
  } else if (!data.email?.match(emailRegex)) {
    errorMsg = "Email adresi hatalı";
  } else if (data.phones.length === 0) {
    errorMsg = "En az bir telefon numarasi gerekir";
  } else if ((data.name?.split(" ")?.length || 0) < 2) {
    errorMsg = "Hesap adı geçersiz, en az iki kelime olmalı";
  }

  if (errorMsg) {
    await popup(errorMsg);
    return null;
  }

  return data;
};
